import SpainCnoOccupation from 'modules/contracts/store/models/SpainCnoOccupation'

import { PayrollLegalEntityResource } from 'modules/contracts/store/collections/payrollLegalEntityResource'

class CnoOccupations extends PayrollLegalEntityResource<SpainCnoOccupation> {
  get cacheKey(): string {
    return 'cnoOccupations'
  }

  model() {
    return SpainCnoOccupation
  }
}

export { CnoOccupations }
